// components/schoolGrades.js

const schoolgradesData = {
  primaryarr: [
    "K-8",
    "K-12",
    "K-1",
    "K-5",
    "1-12",
    "K",
    "1",
    "K-6",
    "K-2",
    "3-6",
    "1-8",
    "1-6",
    "2-12",
    "K-7",
    "K-3",
    "K-4",
    "1-5",
    "3-5",
    "2-8",
    "3-12",
    "3-8",
    "4-5",
    "K-10",
    "1-10",
    "4",
  ],
  middlearr: [
    "6-12",
    "K-8",
    "6-8",
    "8-12",
    "7-12",
    "K-12",
    "6-7",
    "1-12",
    "7-8",
    "1-8",
    "2-12",
    "K-7",
    "6-9",
    "5-12",
    "5-8",
    "7-10",
    "7",
    "4-12",
    "2-8",
    "8-11",
    "3-12",
    "4-8",
    "3-8",
    "8",
    "K-10",
    "1-10",
    "7-9",
    "5-6",
    "7-11",
    "4-6",
    "6",
  ],
  higharr: [
    "6-12",
    "8-12",
    "7-12",
    "K-12",
    "10-12",
    "1-12",
    "9-12",
    "11-12",
    "12",
    "2-12",
    "5-12",
    "9-10",
    "7-10",
    "4-12",
    "8-11",
    "3-12",
    "9-11",
    "9",
    "K-10",
    "1-10",
    "7-11",
    "10",
  ],
};

export default schoolgradesData;
